import { RefObject, useState } from "react";
import { MergedGpEventResponse } from "../../../../types";
import { MediaPlayerInstance } from "@vidstack/react";
import { handlePlayEvent } from "../../../../functions";

export function calculatePercentage(
	mergedEvent: MergedGpEventResponse,
	time: number,
	prependMax: number,
	appendMax: number,
	fullRange = false,
): number {
	if (fullRange) {
		const maxPrepend = prependMax * 1000;
		const maxAppend = appendMax * 1000;

		return Math.round(
			((time - (mergedEvent.videoTime - maxPrepend)) / (mergedEvent.lastVideoTime + maxAppend - (mergedEvent.videoTime - maxAppend))) * 100,
		);
	}

	return Math.round(((time - mergedEvent.startTime) / (mergedEvent.endTime - mergedEvent.startTime)) * 100);
}

interface EventItemProgressHolderProps {
	mergedEvent: MergedGpEventResponse;
	prependMax: number;
	appendMax: number;
	isHighlight: boolean;
	width: number;
	playerRef: RefObject<MediaPlayerInstance> | null;
}

export function EventItemProgressHolder({ mergedEvent, prependMax, appendMax, isHighlight, width, playerRef }: EventItemProgressHolderProps) {
	const [mousePosition, setMousePosition] = useState<number | null>(null);

	const handleEventProgress = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, navigate: boolean) => {
		const rect = e.currentTarget.getBoundingClientRect();
		const size = Math.round(((e.clientX - rect.left) / rect.width) * 100);

		setMousePosition(size);

		if (navigate) {
			e.stopPropagation();
			const time = mergedEvent.startTime + (mergedEvent.endTime - mergedEvent.startTime) * (size / 100);

			handlePlayEvent(playerRef, time);
		}
	};

	return (
		<div className="eventItem__progress__holder" style={isHighlight ? {} : { paddingLeft: "0px" }}>
			<div
				className="eventItem__progress__ghost"
				style={{
					paddingLeft: `${calculatePercentage(mergedEvent, mergedEvent.startTime, prependMax, appendMax, true)}%`,
					paddingRight: `${100 - calculatePercentage(mergedEvent, mergedEvent.endTime, prependMax, appendMax, true)}%`,
				}}
			>
				<div
					className="eventItem__progress"
					onClick={(e) => handleEventProgress(e, true)}
					onMouseMove={(e) => handleEventProgress(e, false)}
					onMouseLeave={() => setMousePosition(null)}
				>
					<div className="eventItem__progress__track" style={{ width: `${width}%` }} />
					{!!mousePosition && (
						<div className="eventItem__progress__track eventItem__progress__track--user" style={{ width: `${mousePosition}%` }} />
					)}
				</div>
				{mergedEvent.hits.map((hitTime, hitIndex) => (
					<div
						className="eventItem__hit"
						style={{ left: `${calculatePercentage(mergedEvent, hitTime, prependMax, appendMax, true)}%` }}
						key={`${hitIndex}-${hitTime}`}
					/>
				))}
			</div>
		</div>
	);
}
